export default "__VITE_ASSET__AcQFIlqr__"